<div class="alert" [class.open]="open()">
  @if (notifications()) {
    <span class="notifications" [class.isDouble]="doubleDigits()">{{ notifications() }}</span>
  }
  <ui-inline-svg class="icon" [name]="open() === false ? 'alert-selected' : 'alert-selected'"></ui-inline-svg>
</div>
